import { render, staticRenderFns } from "./RegisterLinkPopup.vue?vue&type=template&id=f4cdc648&scoped=true"
import script from "./RegisterLinkPopup.vue?vue&type=script&lang=js"
export * from "./RegisterLinkPopup.vue?vue&type=script&lang=js"
import style0 from "./RegisterLinkPopup.vue?vue&type=style&index=0&id=f4cdc648&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4cdc648",
  null
  
)

export default component.exports